<!--
    DUMMY CHECKBOX SO THAT WHEN WE DO THE EDIT THE CHECKBOX DOESN'T DISAPEAR
-->
<div
	style="display: flex; flex-direction: row; align-items: center; height: 100%"
>
	<mat-checkbox></mat-checkbox>
</div>
